// eslint-disable-next-line import/no-cycle
import NetworkContent from '@/helpers/networking/NetworkContent';

export default {
  state: {
    timelineData: [],
    yourWayToLevelData: [],
    personalJourneyStats: [],
    currentLevel: 0,
    weeksCompleted: 0,
    completedWeeksToLevel: 0,
    assessmentsSubmittedCount: 0,
    kssCreatedCount: 0,
    mindset360CreatedCount: 0,
    workshopCreatedCount: 0,
    travelBuddiesMetCount: 0,
    devTipsDoneCount: 0,
    devTipsCount: 0,
    loginCount: 0,
    moodomatSubmittedCount: 0,
    mindsetSubmittedCount: 0,
    mindsetCount: 0,
    kssSubmittedCount: 0,
    kssCount: 0,
    nextGoalOverflow: null,
    nextLvlOverflow: null,
    nextNewFeatOverflow: null,

    // TIMELINE ICONS VISIBILITY
    showNextLevelOnTimeline: true,
    showPersonalGoalsOnTimeline: true,
    showWorkshopOnTimeline: true,
    showNewFeatureOnTimeline: true,
  },
  getters: {
    getTimelineData: (state) => state.timelineData,
    getYourWayToLevelData: (state) => state.yourWayToLevelData,
    getPersonalJourneyStats: (state) => state.personalJourneyStats,
    getCurrentLevel: (state) => state.currentLevel,
    getWeeksCompleted: (state) => state.weeksCompleted,
    getAsessmentsSubmittedCount: (state) => state.assessmentsSubmittedCount,
    getMoodomatSubmittedCount: (state) => state.moodomatSubmittedCount,
    getMindsetSubmittedCount: (state) => state.mindsetSubmittedCount,
    getMindsetCount: (state) => state.mindsetCount,
    getKssSubmittedCount: (state) => state.kssSubmittedCount,
    getKssCount: (state) => state.kssCount,
    getKssCreatedCount: (state) => state.kssCreatedCount,
    getMindset360CreatedCount: (state) => state.mindset360CreatedCount,
    getWorkshopCreatedCount: (state) => state.workshopCreatedCount,
    getTravelBuddiesMetCount: (state) => state.travelBuddiesMetCount,
    getDevTipsDoneCount: (state) => state.devTipsDoneCount,
    getDevTipsCount: (state) => state.devTipsCount,
    getLoginCount: (state) => state.loginCount,
    getCompletedWeeksToLevel: (state) => state.completedWeeksToLevel,
    getNextGoalOverflow: (state) => state.nextGoalOverflow,
    getNextLvlOverflow: (state) => state.nextLvlOverflow,
    getNextNewFeatOverflow: (state) => state.nextNewFeatOverflow,

    getShowNextLevelOnTimeline: (state) => state.showNextLevelOnTimeline,
    getShowPersonalGoalsOnTimeline: (state) => state.showPersonalGoalsOnTimeline,
    getShowWorkshopOnTimeline: (state) => state.showWorkshopOnTimeline,
    getShowNewFeatureOnTimeline: (state) => state.showNewFeatureOnTimeline,
  },
  mutations: {
    setTimelineData: (state, data) => {
      state.timelineData = data.filter((el) => {
        if (!el.date) return false;
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        return new Date(el.date) >= oneMonthAgo;
      });
    },
    setYourWayToLevelData: (state, data) => {
      // MIGRATED: Now uses levelProgress structure with goals array
      const goals = [];
      data?.goals?.forEach((goal) => goals.push({
        completed: goal.progress,
        maximum: goal.requiredCompletions,
        label: goal.title,
        isCompleted: goal.completed,
        xp: goal.xp,
      }));
      state.yourWayToLevelData = goals;
      state.currentLevel = data?.currentLevel || 0;
    },
    setWeeksCompleted: (state, data) => {
      state.completedWeeksToLevel = data;
    },
    setPersonalJourneyStats: (state, data) => {
      state.assessmentsSubmittedCount = data.assessmentsSubmittedCount;
      state.kssCreatedCount = data.kssCreatedCount;
      state.mindset360CreatedCount = data.mindset360CreatedCount;
      state.workshopCreatedCount = data.workshopCreatedCount;
      state.travelBuddiesMetCount = data.travelBuddiesMetCount;
      state.devTipsDoneCount = data.devTipsDoneCount;
      state.devTipsCount = data.devTipsCount;
      state.loginCount = data.loginCount;
      state.moodomatSubmittedCount = data.moodomatSubmittedCount;
      state.mindsetSubmittedCount = data.mindsetSubmittedCount;
      state.mindsetCount = data.mindsetCount;
      state.kssSubmittedCount = data.kssSubmittedCount;
      state.kssCount = data.kssAssignedCount;
      state.nextGoalOverflow = data.nextGoalOverflow;
      state.nextLvlOverflow = data.nextLvlOverflow;
      state.nextNewFeatOverflow = data.nextNewFeatOverflow;
    },
    toggleShowNextLevelOnTimeline(state) {
      state.showNextLevelOnTimeline = !state.showNextLevelOnTimeline;
    },
    toggleShowPersonalGoalsOnTimeline(state) {
      state.showPersonalGoalsOnTimeline = !state.showPersonalGoalsOnTimeline;
    },
    toggleShowWorkshopOnTimeline(state) {
      state.showWorkshopOnTimeline = !state.showWorkshopOnTimeline;
    },
    toggleShowNewFeatureOnTimeline(state) {
      state.showNewFeatureOnTimeline = !state.showNewFeatureOnTimeline;
    },
  },
  actions: {
    async fetchPersonalJourneyData({ commit }) {
      const { data } = await NetworkContent.getPersonalJourney();
      commit('setTimelineData', data.data.timeLine);
      commit('setYourWayToLevelData', data.data.levelProgress);
      commit('setWeeksCompleted', data.data.thisLevelWeeksCompleted);
      commit('setPersonalJourneyStats', data.data);
    },
  },
};
